const updateAuth = (state, action) => {
  if (state === undefined) {
    return {
      authenticated: false,
      user: null,
      errorLogin: null,
      loading: false,
      loadFirst: false,
      loadingUser: false,
      errorPassword: null,
      loadingUnpaid: true,
    };
  }

  switch (action.type) {
    case "SET_AUTHENTICATED":
      return {
        ...state.auth,
        authenticated: action.payload,
      };
    case "LOGIN_ERROR":
      return {
        ...state.auth,
        errorLogin: action.payload,
      };
    case "LOADING_UNPAID":
      return {
        ...state.auth,
        loadingUnpaid: action.payload,
      };
    case "ERROR_PASSWORD":
      return {
        ...state.auth,
        errorPassword: action.payload,
      };
    case "SET_USER":
      return {
        ...state.auth,
        user: action.payload,
      };
    case "LOGIN_FIRST_LOAD":
      return {
        ...state.auth,
        loadFirst: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state.auth,
        loading: action.payload,
      };
    case "LOADING_USER":
      return {
        ...state.auth,
        loadingUser: action.payload,
      };

    default:
      return state.auth;
  }
};

export default updateAuth;
